import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IDocumentDetailsParams } from './IDocumentDetailsParams';
import { IDocumentDetailsResponse } from './IDocumentDetailsResponse';

export const getDocumentDetails = (params: IDocumentDetailsParams) : AxiosPromise<IDocumentDetailsResponse> => {
  return Fetch().then(axios => axios.post('documents/details', params));
};
